import { AutoLoanCriteria } from '@nemuru-eng/js-api-client';

import { GridDateTime } from '@/components/modules/_shared/utils/DataGridFields/GridDateTime';
import { Text } from '@/components/shared/components/Text';

export const scheduledDeliveryDateFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.12,
    field: 'scheduled_delivery_date',
    sortable: true,
    align: 'right',
    headerName: <Text tId={'SCHEDULED_DELIVERY_DATE'} />,
    renderCell: (rowData: { row: AutoLoanCriteria }) => {
      const value = rowData.row.scheduledDeliveryDate;

      if (!value) return '-';

      return <GridDateTime value={value} />;
    },
  };
};

